module.exports = __webpack_public_path__ + "img/hauptseite-zimmer-frei.badf1037.jpg";